import AutogrowingTextarea from './view'

export default AutogrowingTextarea
